import update from 'immutability-helper'

import * as actions from '../actions/actions'

const initialState = {
  profile: {
    idBank: '',
    corporateSenderId: '',
    fullName: '',
    description: '',
    enabled: true,
    username: '',
    phone: '',
    email:'',
    reset: true,
    newPassword: '',
    newPasswordConfirm: '',
    role: '',
    imageString:'',
    language: '',
    otp: ''
  },
  error: '',
  passwordChange:true
}

export default function profile(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_PROFILE_EDIT_SUCCESS:
      return fetchProfileEditSuccess(state, action)
    case actions.FETCH_PROFILE_EDIT_FAILURE:
      return fetchProfileEditFailure(state, action)
    case actions.EDIT_PROFILE_ID_BANK_FIELD_CHANGE:
      return editProfileIdBankFieldChange(state, action)
    case actions.EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE:
      return editProfileCorporateSenderIdFieldChange(state, action)
    case actions.EDIT_PROFILE_FULL_NAME_FIELD_CHANGE:
      return editProfileFullNameFieldChange(state, action)
    case actions.EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE:
      return editProfileDescriptionFieldChange(state, action)
    case actions.EDIT_PROFILE_ENABLED_FIELD_CHANGE:
      return editProfileEnabledFieldChange(state, action)
    case actions.EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE:
      return editProfileProfilenameFieldChange(state, action)
    case actions.EDIT_PROFILE_PHONE_FIELD_CHANGE:
      return editProfilePhoneFieldChange(state, action)
    case actions.EDIT_PROFILE_EMAIL_FIELD_CHANGE:
      return editProfileEmailFieldChange(state, action)
    case actions.EDIT_PROFILE_RESET_FIELD_CHANGE:
      return editProfileResetFieldChange(state, action)
    case actions.EDIT_PROFILE_PASSWORD_FIELD_CHANGE:
      return editProfilePasswordFieldChange(state, action)
    case actions.EDIT_PROFILE_ROLE_FIELD_CHANGE:
      return editProfileRoleFieldChange(state, action)
    case actions.EDIT_PROFILE_CLEAN:
      return editProfileClean(state, action)
    case actions.EDIT_PROFILE_LANGUAGE_FIELD_CHANGE:
      return editProfileLanguageFieldChange(state, action)
    case actions.EDIT_USER_PICTURE_UPLOAD:
      return editProfileUploadPictureField(state,action)
    case actions.UPDATE_PROFILE_EDIT_FAILURE:
      return editProfileError(state,action)
    case actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE:
      return editProfileNewPasswordChange(state,action)
    case actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE:
      return editProfileNewPasswordConfirmFieldChange(state, action)
    case actions.EDIT_PROFILE_OTP_CHANGE:
      return editProfileOtpChange(state,action)
    case actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN:
      return editProfileNewPasswordClean(state, action)
    case actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN:
      return editProfileNewPasswordConfirmClean(state, action)
    default:
      return state
  }
}

const editProfileNewPasswordClean = (state,action) =>{
  return update(
      state,
      {profile: {newPassword: {$set: ''}}}
  )
}

const editProfileNewPasswordConfirmClean = (state,action) =>{
  return update(
      state,
      {profile: {newPasswordConfirm: {$set: ''}}}
  )
}

const editProfileNewPasswordChange = (state,action) =>{
  return update(
      state,
      {profile: {newPassword: {$set: action.value}}}
  )
}

const editProfileNewPasswordConfirmFieldChange = (state, action) => {
  return update(
      state,
      {profile: {newPasswordConfirm: {$set: action.value}}}
  )
}

const editProfileOtpChange = (state,action) =>{
  return update(
      state,
      {profile: {otp: {$set: action.value}}}
  )
}

const editProfileError = (state,action) =>{
  return {
    ...state,
    error: action.error
  }
}

const fetchProfileEditSuccess = (state, action) => {
  return {
    ...state,
    profile: action.value,
    error: null
  }
}

const fetchProfileEditFailure = (state, action) => {
  return {
    ...state,
    profile: null,
    error: action.error
  }
}

const editProfileIdBankFieldChange = (state, action) => {
  return update(
    state,
    {profile: {idBank: {$set: action.value}}}
  )
}

const editProfileCorporateSenderIdFieldChange = (state, action) => {
  return update(
    state,
    {profile: {corporateSenderId: {$set: action.value}}}
  )
}

const editProfileFullNameFieldChange = (state, action) => {
  return update(
    state,
    {profile: {fullName: {$set: action.value}}}
  )
}

const editProfileDescriptionFieldChange = (state, action) => {
  return update(
    state,
    {profile: {description: {$set: action.value}}}
  )
}

const editProfileEnabledFieldChange = (state, action) => {
  return update(
    state,
    {profile: {enabled: {$set: action.value}}}
  )
}

const editProfileProfilenameFieldChange = (state, action) => {
  return update(
    state,
    {profile: {username: {$set: action.value}}}
  )
}

const editProfilePhoneFieldChange = (state, action) => {
  return update(
    state,
    {profile: {phone: {$set: action.value}}}
  )
}

const editProfileEmailFieldChange = (state, action) => {
  return update(
    state,
    {profile: {email: {$set: action.value}}}
  )
}

const editProfileResetFieldChange = (state, action) => {
  return update(
    state,
    {profile: {reset: {$set: action.value}}}
  )
}

const editProfilePasswordFieldChange = (state, action) => {
  return update(
    state,
    {profile: {password: {$set: action.value}}}
  )
}

const editProfileRoleFieldChange = (state, action) => {
  return update(
    state,
    {profile: {role: {$set: action.value}}}
  )
}

const editProfileClean = (state, action) => {
  return initialState;
}

const editProfileUploadPictureField=(state,action) => {
  return update(
      state,
      {profile:{imageString: {$set:action.value}}}
  )
}

const editProfileLanguageFieldChange = (state, action) => {
  return update(
    state,
    {profile: {language: {$set: action.value}}}
  )
}